// extracted by mini-css-extract-plugin
export default {"header-container":"Account_header-container__xJcL3","flex":"Account_flex__235ef"};